import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CoursesEffects } from './+state/courses.effects';
import { CoursesFacade } from './+state/courses.facade';
import * as fromCourses from './+state/courses.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromCourses.COURSES_FEATURE_KEY, fromCourses.reducer),
    EffectsModule.forFeature([CoursesEffects]),
  ],
  providers: [CoursesFacade],
})
export class OnmatStoreCoursesModule {}
